// from LoggedInState to LoggedOutState or LoggedInState
import { AuthState, isLoggedInState } from "./authState";
import { any, nothing, Updater, wait, Widget } from 'widgets-for-react';
import { Api, logout as logoutToState, } from "./api_to_state";
import { options } from "./utils"

export function logout(options: options, api: Api, s0: AuthState): Widget<Updater<AuthState>> {
  if (s0.status === "logged in" && isLoggedInState(s0)) {
    return any<Updater<AuthState>>([
      s0.loggedInState === "logged in" ?
        any<Updater<AuthState>>([
          logoutToState(api, s0)
        ]) :
        s0.loggedInState === "logged in - logout api error" ?
          wait(500, { key: "login-widget-logging-out-promise" })(() => (s : AuthState) : AuthState => isLoggedInState(s) && s.loggedInState !== "logged in - logout api error" ? s : ({ ...s, loggedInState: "logged in - logging out" })) :
          nothing()
    ])
  } else {
    return nothing()
  }
}
